export default __webpack_public_path__ + "bd240b360fd3ce3cc4b7a951b6cc611a.png";